import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import NoSsr from '@material-ui/core/NoSsr';
import {Backdrop} from '@material-ui/core';

interface LoaderProps {}
const Loader: React.FC<LoaderProps> = () => {
  return (
    <NoSsr>
      <Box
        style={{zIndex: 1400}}
        height='100%'
        display='flex'
        flex={1}
        alignItems='center'
        justifyContent='center'
        position='absolute'
        top={0}
        left={0}
        right={0}
        bottom={0}>
        <Backdrop
          style={{
            color: 'grey',
          }}
          open={true}>
          <CircularProgress style={{color: 'white'}} />
        </Backdrop>
      </Box>
    </NoSsr>
  );
};

export default Loader;
